import { useLayoutEffect, useRef } from 'react'
import { Modal } from 'bootstrap'

export const ConfirmModalComponent = props => {
    const { titre, message, open, setOpen, onConfirm } = props;

    const modalRef = useRef();

    useLayoutEffect(() => {

        if (!modalRef || !modalRef.current) {
            return;
        }

        let modal = Modal.getOrCreateInstance(modalRef.current);

        if (open) {
            modal.show();
        }
        else {
            modal.hide();
        }
    }, [open]);

    const onYes = () => {
        setOpen(false);
        onConfirm();
    }

    const onNo = () => {
        setOpen(false);
    }

    return <div ref={modalRef}   className="modal frontModal" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">{titre}</h5>
                </div>
                <div className="modal-body">
                    <p> {message}</p>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-success" data-bs-dismiss="modal"  onClick={ onYes } >Oui</button>
                    <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={ onNo} >Non</button>
                </div>
            </div>
        </div>
        </div>
}